var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 256 256",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        preserveAspectRatio: "xMidYMid",
      },
    },
    [
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            { attrs: { id: "a", x1: "50%", x2: "50%", y1: "0%", y2: "100%" } },
            [
              _c("stop", { attrs: { offset: "0%", "stop-color": "#2AABEE" } }),
              _c("stop", {
                attrs: { offset: "100%", "stop-color": "#229ED9" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("path", {
        attrs: {
          fill: "url(#a)",
          d: "M128 0C94.06 0 61.48 13.494 37.5 37.49A128.038 128.038 0 0 0 0 128c0 33.934 13.5 66.514 37.5 90.51C61.48 242.506 94.06 256 128 256s66.52-13.494 90.5-37.49c24-23.996 37.5-56.576 37.5-90.51 0-33.934-13.5-66.514-37.5-90.51C194.52 13.494 161.94 0 128 0Z",
        },
      }),
      _c("path", {
        attrs: {
          fill: "#FFF",
          d: "M57.94 126.648c37.32-16.256 62.2-26.974 74.64-32.152 35.56-14.786 42.94-17.354 47.76-17.441 1.06-.017 3.42.245 4.96 1.49 1.28 1.05 1.64 2.47 1.82 3.467.16.996.38 3.266.2 5.038-1.92 20.24-10.26 69.356-14.5 92.026-1.78 9.592-5.32 12.808-8.74 13.122-7.44.684-13.08-4.912-20.28-9.63-11.26-7.386-17.62-11.982-28.56-19.188-12.64-8.328-4.44-12.906 2.76-20.386 1.88-1.958 34.64-31.748 35.26-34.45.08-.338.16-1.598-.6-2.262-.74-.666-1.84-.438-2.64-.258-1.14.256-19.12 12.152-54 35.686-5.1 3.508-9.72 5.218-13.88 5.128-4.56-.098-13.36-2.584-19.9-4.708-8-2.606-14.38-3.984-13.82-8.41.28-2.304 3.46-4.662 9.52-7.072Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }